export const meta = {
  title: 'Siaran pemasaran: capai semua yang berkata ya',
  updatedAt: '2026-07-17',
  related: ['promotions', 'notifications'],
};

Siaran ialah notifikasi tolak yang anda tulis sekali dan hantar kepada seluruh audiens — promosi baharu, pakej baharu, waktu perayaan. Ia mendarat di telefon pelanggan melalui aplikasi yang mereka pasang daripada QR anda.

## Mengarang

Halaman **Pemasaran** memaparkan kempen lepas di kiri dan pengarang di kanan. Sesebuah kempen ialah tajuk, mesej, pautan pilihan ke satu skrin dalam aplikasi anda, dan audiens. Jika anda tidak mahu merenung kotak kosong, bantuan **Draf AI** menukar satu ayat niat kepada tajuk dan mesej yang boleh anda sunting sebelum menyimpan.

## Audiens

Empat audiens sedia ada:

- **Semua pelanggan** — semua yang pernah membayar di outlet anda.
- **Aktif 30 hari terakhir** — segmen paling hangat anda.
- **Tahap Perak+** — pelanggan setia yang wajar diberi ganjaran.
- **Tahap Emas sahaja** — tawaran khas VIP.

Satu nota jujur tentang "semua": senarai yang boleh anda capai ialah pelanggan yang telah melengkapkan sekurang-kurangnya satu cucian berbayar dengan anda — pada saat itulah seseorang menyertai senarai pelanggan anda. Orang yang mengimbas QR anda tetapi tidak pernah mencuci tidak boleh menerima siaran.

## Apa yang "Hantar sekarang" benar-benar buat

Penghantaran keluar serta-merta, dan setiap penerima melalui tiga pintu yang wujud untuk _perlindungan mereka_:

- Menarik diri daripada pemasaran? **Dilangkau.** Pilihan mereka sentiasa dihormati.
- Dalam waktu senyap mereka (22:00–08:00 melainkan diubah)? **Dilangkau.** Pemasaran tidak pernah menembusi waktu senyap.
- Tidak pernah membenarkan notifikasi pada telefon? **Dilangkau** — tiada apa untuk dihantar.

Selepas itu anda menerima ringkasan yang menamakan setiap kategori: dihantar, sampai, dilangkau kerana keutamaan, dilangkau kerana waktu senyap, dilangkau kerana tiada kebenaran, gagal. Jadi apabila "Semua pelanggan" mencapai 60% senarai anda, anda nampak sebabnya dengan tepat — tiada misteri.

## Had yang menjauhkan anda daripada masalah

- **10 siaran sehari** bagi setiap perniagaan. Cukup untuk pemasaran sebenar; terlalu sedikit untuk spam.
- Satu penghantaran mengendalikan sehingga **10,000 penerima**. Audiens lebih besar diproses sehingga had itu dan ringkasan menyatakannya terus-terang — tiada potongan senyap.
- Kempen yang telah dihantar dikunci dan tidak boleh keluar dua kali. Untuk menghantar mesej yang sama semula, karang kempen baharu.

## Had yang jujur

Penghantaran adalah **serta-merta sahaja** — belum ada penjadualan untuk masa hadapan. Notifikasi tolak ialah **satu-satunya saluran** — tiada siaran WhatsApp atau SMS. Dan siaran keluar dalam **satu bahasa**: tajuk dan mesej yang anda taip itulah yang dibaca setiap penerima; tiada terjemahan automatik lagi.
